import SiafLiteApiRepository from "../../external/siafLiteApi";

export class SincService {
  constructor() {
    this.urlBase = "/sinc";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  sincronizar() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }

  sincronizarNfSaida() {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/nf-saida`).get();
  }
}
